// Filter options for furniture catalog

export const CATEGORY_OPTIONS = [
  { id: 0, label: 'Sofás', value: 'sofas' },
  { id: 1, label: 'Mesas', value: 'mesas' },
  { id: 2, label: 'Cadeiras', value: 'cadeiras' },
  { id: 3, label: 'Balanços', value: 'balancos' },
  { id: 4, label: 'Banquetes', value: 'banquetes' },
  { id: 5, label: 'Espreguiçadeiras', value: 'espreguicadeiras' },
  { id: 6, label: 'Bancos', value: 'bancos' }
];

export const COR_OPTIONS = [
  // Cores básicas - serão preenchidas conforme necessário
];

export const MATERIAL_OPTIONS = [
  "madeira",
  "aço", 
  "aluminio",
  "vidro",
  "marmore",
  "vime",
  "bambu",
  "couro",
  "metal",
];

export const REVESTIMENTO_OPTIONS = [
  // Opções de revestimento - serão preenchidas conforme necessário
];


export const MADEIRA_OPTIONS = [
  "Peroba rosa",
  "Teca",
  "Ipê", 
  "Jeguitiba",
  "Cumaru",
];

export const ESPUMA_OPTIONS = [
  "espuma D33",
  "espuma D45"
];

export const ACABAMENTO_OPTIONS = [
  // Opções de acabamento - serão preenchidas conforme necessário
];

export const PINTURA_OPTIONS = [
  "Marrom ascortem",
  "Champagnhe",
  "Preto microtestura",
  "Fendi",
  "Cinza grafite", 
  "Terracota",
];

// Convert arrays to filter format with counts
export const createFilterOptions = (options, baseName = '') => {
  return options?.map((option, index) => ({
    id: option?.toLowerCase()?.replace(/\s+/g, '-')?.replace(/[^\w-]/g, ''),
    label: option,
    count: Math.floor(Math.random() * 50) + 1 // Random count for demo
  }));
};